import { Component, Input } from '@angular/core';

@Component({
	selector: 'ac-wizard-steps',
	templateUrl: './wizard-steps.component.html',
	styleUrls: ['./wizard-steps.component.scss']
})
export class WizardStepsComponent {
	@Input() public activeStepIndex: number;
	@Input() public stepsLabels: Array<string>;
}
